/**
 * Reactions -- emoji reactions on session messages.
 *
 * Any session participant (user or agent) can react to any message.
 * Reactions are persisted in a dedicated DB model and broadcast as
 * transient events for real-time updates.
 */

/**
 * A single emoji reaction on a message, set by any session participant (user or agent).
 *
 * Reactions are persisted in a dedicated DB model and broadcast as transient events
 * for real-time updates.
 *
 * @docLink packages/types/messages#reaction
 */
export type Reaction = {
  /** Unicode emoji character (e.g. "thumbs up", not ":thumbsup:"). */
  emoji: string;
  /** ID of the user (or "agent" for agent reactions). */
  userId: string;
  /** Display name at reaction time (avoids extra lookups for tooltip rendering). */
  userName: string;
  /** Unix epoch milliseconds. */
  timestamp: number;
};

/**
 * Quick-access emojis shown in the reaction bar picker.
 *
 * An `as const` array of eight Unicode emoji characters in display order.
 *
 * @docLink packages/types/messages#reaction
 */
export const QUICK_REACTIONS = [
  "\u{1F44D}",
  "\u{1F440}",
  "\u2705",
  "\u2764\uFE0F",
  "\u{1F914}",
  "\u{1FAE1}",
  "\u{1F44F}",
  "\u{1F389}",
] as const;
